import React from "react";

type CardProps = {
  children: React.ReactNode;
  className?: string;
};

const Card = ({ children, className = "" }: CardProps) => {
  return (
    <div
      className={`tw-rounded-rbah tw-border tw-border-rbah-ink/10 tw-bg-white tw-shadow-[0_10px_30px_rgba(3,2,3,0.08)] ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
